export const cardDefaultValue = {
    id: null,
    cardReference: null,
    maskedPan: null,
    customerReference: null,
    fundingReference: null,
    cardHolderName: null,
    product: null,
    currency: null,
    cardType: null,
    cardForm: null,
    status: null,
};
